import { AdminSchoolNav } from './admin-school-nav'

export const AdminSchool = () => {
  return (
    <>
      <AdminSchoolNav />
    </>
  )
}
